module.exports = __webpack_public_path__ + "img/1531634184.036afc2e.jpg";